import { Box, Typography, styled } from '@mui/material'
import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { show } from '@ebay/nice-modal-react'
import { useAtomValue } from 'jotai'
import TokenLogo from '../TokenLogo'
import { RowCenterY } from '../Rows'
import { TickerAtom } from '../atoms'
import { TICKERS_MAP_BY_NAME } from '@/constants/token'
import SelectTokenDialog from '@/components/SelectTokenDialog'

const Tag = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2px 4px;

  background: rgba(191, 255, 11, 0.1);
  border-radius: 4px;

  margin-right: 4px;

  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  font-feature-settings: 'ss01' on, 'case' on, 'calt' off;
`

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(255, 255, 255, 0.23);
  cursor: pointer;
  padding: 15px 6px 15px 20px;
  width: 100%;

  :hover {
    border-color: #bfff0b;
  }
`

const Text1 = styled(Typography)`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
`

interface AssetSelectProps {
  mode: 'btc' | 'evm'
}

const AssetSelect = ({ mode }: AssetSelectProps) => {
  const tickerName = useAtomValue(TickerAtom)

  const ticker = TICKERS_MAP_BY_NAME[tickerName]

  return (
    <Wrapper
      onClick={() => {
        show(SelectTokenDialog, { mode })
      }}
    >
      <Tag>Asset</Tag>

      <RowCenterY sx={{ columnGap: 8 }}>
        <TokenLogo
          src={mode === 'evm' && ticker.logoSrcSet?.erc ? ticker.logoSrcSet.erc : ticker.logoSrcSet.brc}
          alt={ticker.name}
          size={24}
        />
        <Text1>{tickerName}</Text1>
        <ExpandMoreIcon />
      </RowCenterY>
    </Wrapper>
  )
}

export default AssetSelect
